import initialState from './initialState';
import {
  CLOSED_PERIODS_ADMIN_GET_LIST_INIT,
  CLOSED_PERIODS_ADMIN_GET_LIST_SUCCESS,
  CLOSED_PERIODS_ADMIN_GET_LIST_FAILURE,
  CLOSED_PERIODS_ADMIN_SAVE_INIT,
  CLOSED_PERIODS_ADMIN_SAVE_SUCCESS,
  CLOSED_PERIODS_ADMIN_SAVE_FAILURE,
  CLOSED_PERIODS_ADMIN_SET_SAVE_DATA_BY_KEY,
  CLOSED_PERIODS_ADMIN_SAVE_RESET,
	CLOSED_PERIODS_ADMIN_GET_CALCULATIONS_HISTORY_INIT,
	CLOSED_PERIODS_ADMIN_GET_CALCULATIONS_HISTORY_SUCCESS,
	CLOSED_PERIODS_ADMIN_GET_CALCULATIONS_HISTORY_FAILURE,
	CLOSED_PERIODS_ADMIN_DOWNLOAD_CALCULATION_REPORT_FILE_INIT,
	CLOSED_PERIODS_ADMIN_DOWNLOAD_CALCULATION_REPORT_FILE_SUCCESS,
	CLOSED_PERIODS_ADMIN_DOWNLOAD_CALCULATION_REPORT_FILE_FAILURE,
  CLOSED_PERIODS_ADMIN_DOWNLOAD_CALCULATION_UNIFIED_REPORT_FILE_INIT,
  CLOSED_PERIODS_ADMIN_DOWNLOAD_CALCULATION_UNIFIED_REPORT_FILE_SUCCESS,
  CLOSED_PERIODS_ADMIN_DOWNLOAD_CALCULATION_UNIFIED_REPORT_FILE_FAILURE,
  CLOSED_PERIODS_ADMIN_GET_PERIODS_LIST_INIT,
  CLOSED_PERIODS_ADMIN_GET_PERIODS_LIST_SUCCESS,
  CLOSED_PERIODS_ADMIN_GET_PERIODS_LIST_FAILURE,
  CLOSED_PERIODS_ADMIN_ROLL_BACK_PERIOD_INIT,
  CLOSED_PERIODS_ADMIN_ROLL_BACK_PERIOD_SUCCESS,
  CLOSED_PERIODS_ADMIN_ROLL_BACK_PERIOD_FAILURE,
  CLOSED_PERIODS_ADMIN_DELETE_PREPARE_INIT,
  CLOSED_PERIODS_ADMIN_DELETE_INIT,
  CLOSED_PERIODS_ADMIN_DELETE_SUCCESS,
  CLOSED_PERIODS_ADMIN_DELETE_FAILURE,
  CLOSED_PERIODS_GET_CUSTOMER_INIT,
  CLOSED_PERIODS_GET_CUSTOMER_SUCCESS,
  CLOSED_PERIODS_GET_CUSTOMER_FAILURE,
  CLOSED_PERIODS_ADMIN_RESET
} from '../../actions/closedPeriodsAdmin/types';
import ReducersTooling from '../../../tooling/reducersTooling';

export default function closedPeriodsAdmin(state = initialState, action) {
  switch (action.type) {      
    case CLOSED_PERIODS_ADMIN_GET_LIST_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "list");
    case CLOSED_PERIODS_ADMIN_GET_LIST_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "list");
    case CLOSED_PERIODS_ADMIN_GET_LIST_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "list");
    case CLOSED_PERIODS_ADMIN_SAVE_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitSave(initialState, state, action, "save");
    case CLOSED_PERIODS_ADMIN_SAVE_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessSave(initialState, state, action, "save");
    case CLOSED_PERIODS_ADMIN_SAVE_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureSave(initialState, state, action, "save");
    case CLOSED_PERIODS_ADMIN_SET_SAVE_DATA_BY_KEY:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSetDataByKeySave(initialState, state, action, "save");
    case CLOSED_PERIODS_ADMIN_SAVE_RESET:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateResetSave(initialState, state, action, "save");
    case CLOSED_PERIODS_ADMIN_GET_CALCULATIONS_HISTORY_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "calculationsHistory");
    case CLOSED_PERIODS_ADMIN_GET_CALCULATIONS_HISTORY_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "calculationsHistory");
    case CLOSED_PERIODS_ADMIN_GET_CALCULATIONS_HISTORY_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "calculationsHistory");	 
	  case CLOSED_PERIODS_ADMIN_DOWNLOAD_CALCULATION_REPORT_FILE_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "downloadCalculationReport");
    case CLOSED_PERIODS_ADMIN_DOWNLOAD_CALCULATION_REPORT_FILE_SUCCESS:
      return ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "downloadCalculationReport");
    case CLOSED_PERIODS_ADMIN_DOWNLOAD_CALCULATION_REPORT_FILE_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "downloadCalculationReport");
    case CLOSED_PERIODS_ADMIN_DOWNLOAD_CALCULATION_UNIFIED_REPORT_FILE_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "downloadCalculationUnifiedReport");
    case CLOSED_PERIODS_ADMIN_DOWNLOAD_CALCULATION_UNIFIED_REPORT_FILE_SUCCESS:
      return ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "downloadCalculationUnifiedReport");
    case CLOSED_PERIODS_ADMIN_DOWNLOAD_CALCULATION_UNIFIED_REPORT_FILE_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "downloadCalculationUnifiedReport");
    case CLOSED_PERIODS_ADMIN_GET_PERIODS_LIST_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "periodsList");
    case CLOSED_PERIODS_ADMIN_GET_PERIODS_LIST_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "periodsList");
    case CLOSED_PERIODS_ADMIN_GET_PERIODS_LIST_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "periodsList");
    case CLOSED_PERIODS_ADMIN_ROLL_BACK_PERIOD_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "rollBackPeriod");
    case CLOSED_PERIODS_ADMIN_ROLL_BACK_PERIOD_SUCCESS:
      return ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "rollBackPeriod");
    case CLOSED_PERIODS_ADMIN_ROLL_BACK_PERIOD_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "rollBackPeriod");
    case CLOSED_PERIODS_ADMIN_DELETE_PREPARE_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStatePrepareDelete(initialState, state, action, "deletePeriod");
    case CLOSED_PERIODS_ADMIN_DELETE_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitDelete(initialState, state, action, "deletePeriod");
    case CLOSED_PERIODS_ADMIN_DELETE_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessDelete(initialState, state, action, "deletePeriod");
    case CLOSED_PERIODS_ADMIN_DELETE_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureDelete(initialState, state, action, "deletePeriod");	
    case CLOSED_PERIODS_GET_CUSTOMER_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "getCustomer");
    case CLOSED_PERIODS_GET_CUSTOMER_SUCCESS:
      return{
        ...(ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "getCustomer")),
        unAuthorized:(action.payload.status == 401) ? true : false,
      };
    case CLOSED_PERIODS_GET_CUSTOMER_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "getCustomer");
    case CLOSED_PERIODS_ADMIN_RESET:
      return initialState;
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./source/client/reducers/closedPeriodsAdmin/index.js